import shortid from 'shortid';

export class SidenavItem {
  name: string;
  icon: string;
  isCustomSvgIcon: boolean;
  route: any;
  routePattern: any;
  parent: SidenavItem;
  subItems: SidenavItem[];
  position: number;
  badge: string;
  badgeColor: string;
  customClass: string;
  id: string;
  tooltip: string;

  constructor(model: any = null) {
    if (model) {
      this.name = model.name;
      this.icon = model.icon;
      this.isCustomSvgIcon = model.isCustomSvgIcon;
      this.route = model.route;
      const pattern = model.routePattern && (new RegExp('^' + model.routePattern + '$'));
      this.routePattern = pattern;
      this.parent = model.parent;
      this.subItems = this.mapSubItems(model.subItems);
      this.position = model.position;
      this.badge = model.badge;
      this.badgeColor = model.badgeColor;
      this.customClass = model.customClass;
      this.id = shortid.generate();
      this.tooltip = model.tooltip || '';
    }
  }

  hasSubItems() {
    if (this.subItems) {
      return this.subItems.length > 0;
    }
    return false;
  }

  hasParent() {
    return !!this.parent;
  }

  mapSubItems(list: SidenavItem[]) {
    if (list) {
      list.forEach((item, index) => {
        list[index] = new SidenavItem(item);
      });

      return list;
    }
  }

  isRouteString() {
    return this.route instanceof String || typeof this.route === 'string';
  }
}


export interface SidenavItemOptions {
  exactRouteMatch?: boolean;
  routePattern?: any;
}
